import Field from "../Field";

export default class PipeSizeField extends Field {

    // TODO: Provide additional rendering guides through something like this:

    /**
     * @overrides Field#getAdditionalComponentProperties
     */
    getAdditionalComponentProperties() {
        let pipeDN = this.step.getField('pipeDN')
        if (pipeDN && pipeDN.value) {
            return {
                tips: [`DN: ${model.pipeDN.value}`]
            }
        }

        return {}
    }

}